import 'whatwg-fetch';

import React, { Component } from 'react';

import { iterUnpack } from '../../services/APIClient';

import HomepageProjects from './HomepageProjects';

export default class HomepageFeaturedProjects extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errors: [],
      projects: [],
    };
  }

  componentWillMount() {
    const props = iterUnpack(JSON.parse(window.props));
    this.setState({
      projects: props.allProjects,
    });
  }

  render() {
    return (
      <div>
        <HomepageProjects projects={this.state.projects} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./js/src/components/homepage/HomepageFeaturedProjects.jsx